import React from 'react'
import CspSignin from 'src/app/CspSignin/CspSignin'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { cspSigninRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const CspSigninAppRoute: AppRoute = {
  id: AppLocation.CspSignin,
  routeProps: cspSigninRouteProps,
  component: <CspSignin />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default CspSigninAppRoute
